import locationApiService from '@/modules/simpleService/services/locationApiService';
import smpConfig from '@/util/smp_config';
import engageApi from '@/services/engageApi';

const getLocation = ({ commit }) => {
  return locationApiService.getLocation(smpConfig.contextConfig.locationId)
    .then((response) => {
      if (response && response.data) {
        commit('SET_LOCATION', response.data);
      }
      return response;
    })
};

const getContactInfo = async ({ commit }, code) => {
  let customerData = {};

  if (smpConfig.contextConfig.extended?.featureConfig?.engageMandantId) {
    customerData = await engageApi.getContactInfo(
      code,
      smpConfig.contextConfig.extended?.featureConfig?.engageMandantId
    );
  } else {
    customerData = await locationApiService.getContactInfo(code);
  }

  if (customerData.salutation && customerData.salutation.toLowerCase() === 'herr') customerData.salutation = 'm';
  if (customerData.salutation && customerData.salutation.toLowerCase() === 'frau') customerData.salutation = 'f';

  return {
    storage: customerData.storage,
    customer: customerData.customer,
    salutation: customerData.salutation,
    surname: customerData.lastname,
    givenname: customerData.firstname,
    plateNumber: customerData.numberPlate,
    telNumber: customerData.phone,
    email: customerData.email,
    companyName: customerData.companyName
  };
};

export default {
  getLocation,
  getContactInfo
};
